import Vue from "vue";
import Router from "vue-router";
import userStore from '../stores/user';
import config from "../config";
// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const Dashboard = () => import("@/views/Dashboard");
const TractionDashboard = () => import("@/views/traction/TractionDashboard");
const LogDetails = () => import("@/views/LogDetails");
const LogDetailsAmbulance = () => import("@/views/LogDetailsAmbulance");
const smsLog = () => import("@/views/smsLog");
const LogTransport = () => import("@/views/LogTransport");
const Role = () => import("@/views/Role");
const AdminUser = () => import("@/views/AdminUser");
const Suggestions = () => import("@/views/Suggestions");
const UserProfile = () => import("@/views/UserProfile");
const AssignedTickets = () => import("@/views/AssignedTickets");
const TicketList = () => import("@/views/Tickets");
const RedFlag = () => import("@/views/RedFlag");
const ActiveModules = () => import("@/views/ActiveModules");
const Chats = () => import("@/views/Chats");
const Chat = () => import("@/views/Chat");
const ReportInappropriate = () => import("@/views/ReportInappropriate");
const userList = () => import("@/views/dashboardNew/userList");
const MobileVersion = () => import("@/views/MobileVersion.vue");
const Releases = () => import("@/views/release.vue");
const ReleaseData = () => import("@/views/releasedata.vue");
const ReferralMarketingAgenciesListing = () =>
  import("@/views/ReferralMarketingAgenciesList.vue");
const ReferredUsersList = () => import("@/views/ReferredUsersList.vue");
const ReferredList = () => import("@/views/ReferredList");
const ReferredListing = () => import("@/views/ReferredListing");
const ReferralDashboard = () => import("@/views/referralDashboard");

const DoctorData = () => import("@/views/DoctorData.vue");
const CityWiseDoctors = () => import("@/views/CityWiseDoctors.vue");

const Colors = () => import("@/views/theme/Colors");
const Typography = () => import("@/views/theme/Typography");

const Charts = () => import("@/views/charts/Charts");
const Widgets = () => import("@/views/widgets/Widgets");
const Logs = () => import("@/views/logs/Logs");

// Views - Components
const Cards = () => import("@/views/base/Cards");
const Forms = () => import("@/views/base/Forms");
const Switches = () => import("@/views/base/Switches");
const Tables = () => import("@/views/base/Tables");
const Tabs = () => import("@/views/base/Tabs");
const Breadcrumbs = () => import("@/views/base/Breadcrumbs");
const Carousels = () => import("@/views/base/Carousels");
const Collapses = () => import("@/views/base/Collapses");
const Jumbotrons = () => import("@/views/base/Jumbotrons");
const ListGroups = () => import("@/views/base/ListGroups");
const Navs = () => import("@/views/base/Navs");
const Navbars = () => import("@/views/base/Navbars");
const Paginations = () => import("@/views/base/Paginations");
const Popovers = () => import("@/views/base/Popovers");
const ProgressBars = () => import("@/views/base/ProgressBars");
const Tooltips = () => import("@/views/base/Tooltips");
const BlogsListing = () => import("@/views/blogs/blogsListing");
const CreateBlog = () => import("@/views/blogs/createBlog");
const BlogDetails = () => import("@/views/blogs/blogDetails");
const newsListing = () => import("@/views/news/newsListing");
const CreateNews = () => import("@/views/news/createNews");
const newsDetails = () => import("@/views/news/newsDetails");

// Views - Buttons
const StandardButtons = () => import("@/views/buttons/StandardButtons");
const ButtonGroups = () => import("@/views/buttons/ButtonGroups");
const Dropdowns = () => import("@/views/buttons/Dropdowns");
const BrandButtons = () => import("@/views/buttons/BrandButtons");

// Views - Icons
const CoreUIIcons = () => import("@/views/icons/CoreUIIcons");
const Brands = () => import("@/views/icons/Brands");
const Flags = () => import("@/views/icons/Flags");

// Views - Notifications
const Alerts = () => import("@/views/notifications/Alerts");
const Badges = () => import("@/views/notifications/Badges");
const Modals = () => import("@/views/notifications/Modals");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

// Users
const Users = () => import("@/views/users/Users");
const User = () => import("@/views/users/User");
const doctorList = () => import("@/views/dashboardNew/doctorList");
const alliedList = () => import("@/views/dashboardNew/alliedList");
const CentreApproval = () => import("@/views/CenterApproval.vue");
const nameChangeList = () => import("@/views/dashboardNew/nameChangeList");
const userListing = () =>
  import("@/views/dashboardNew/userListing/userListing");
const staffListing = () =>
  import("@/views/dashboardNew/staffListing/staffLisiting.vue");
const centreListing = () =>
  import("@/views/dashboardNew/userListing/centerListing");
const activeUsers = () =>
  import("@/views/dashboardNew/registeredUsers/activeUsers");
const inactiveUsers = () =>
  import("@/views/dashboardNew/registeredUsers/inactiveUsers");
const pushNotification = () =>
  import("@/views/dashboardNew/systemNotifications/systemNotification");

const accountsMaster = () =>
  import("@/views/dashboardNew/Accounts/accountsMaster");
const withdrawalList = () =>
  import("@/views/dashboardNew/Accounts/withdrawalList");
const accountSettings = () =>
  import("@/views/dashboardNew/Accounts/accountsSettings");
const corruptedTransactions = () =>
  import("@/views/dashboardNew/Accounts/corruptedTransactions");
const MasterTest = () => import("@/views/master/Tests");
const DoctorTest = () => import("@/views/master/DoctorTest");

const pharmacyMasters = () => import("@/views/pharmacy/master/List");
const pageNotFound = () => import("@/views/pageNotFound.vue");
const pharmacyDoctorMedicines = () =>
  import("@/views/pharmacy/doctor_medicine/List");

// new hospital listing component
const hospitalListing = () =>
  import("@/views/dashboardNew/userListing/hospitalListing");
// new hospital listing detail component
const hospitalListingDetail = () =>
  import("@/views/dashboardNew/userListing/hospitalProfileSummaryDetails");

// new hospital approval component
const hospitalApproval = () =>
  import("@/views/dashboardNew/userListing/hospitalApproval");

// new hospital approval detail component
const hospitalApprovalDetail = () =>
  import("@/views/dashboardNew/userListing/hospitalApprovalSummaryDetails");

// coupon code
// const generatedCoupons = () => import("@/views/couponCode/generatedCoupons");
// const couponTransactionHistory = () =>
//   import("@/views/couponCode/couponTransactionHistory");
// Accounts Masters
const docsmartDashboard = () =>
  import("@/views/dashboardList/docsmartDashboard");
const subscriptionDashboardMasters = () =>
  import("@/views/dashboardList/subscription");
const servicesDashboard = () =>
  import("@/views/dashboardList/servicesDashboard");
const userData = () => import("@/views/dashboardList/userData");

const EnrolledViewDetails = () =>
  import("@/views/couponCode/enrolledViewDetails.vue");
const EnrolledOrganizations = () =>
  import("@/views/couponCode/enrolledOrganization.vue");
const enrolledCouponTransactionHistory = () =>
  import("@/views/couponCode/enrolledCouponTransactionHistory.vue");
const subscriptionDashboard = () =>
  import("@/views/subscription/subscriptionDashboard");
const subscriptionReports = () =>
  import("@/views/subscription/subscriptionReports");
const subscriptionPlans = () =>
  import("@/views/subscription/subscriptionPlans");
const subscriptionPlan = () =>
  import("@/views/subscription/viewSubscriptionPlan");
const recentlyExpiredSubscriptions = () =>
  import("@/views/subscription/recentlyExpiredSubscription.vue");
const subscriptionList = () =>
  import("@/views/subscription/subscriptionList.vue");
const subscriptionHistory = () =>
  import("@/views/subscription/subscriptionHistory");
const userBlogList = () => import("@/views/blogs/userBlogs/userBlogList.vue");
const userBlogDetails = () =>
  import("@/views/blogs/userBlogs/userBlogDetails.vue");
// const userBlogDetails = () =>
//   import("@/views/blogs/userBlogs/userBlogDetails.vue");
const getOtp = () => import("@/views/getOtp");

const cmeList = () => import("@/views/cme/cmeList.vue");
const cmeDetails = () => import("@/views/cme/cmeDetails.vue");
const cmeReports = () => import("@/views/cme/cmeReports.vue");
const healthPackageListing = () =>
  import("@/views/healthPackage/healthPackageListing");
const healthPackageDetails = () =>
  import("@/views/healthPackage/healthPackageDetails");
const importCenters = () => import("@/views/import/center/import");
const ownerList = () => import("@/views/payPerUse/ownerList");
const centreList = () => import("@/views/payPerUse/centreList");
const settings = () => import("@/views/payPerUse/settings");
const payPerUseDashboard = () => import("@/views/payPerUse/payPerUseDashboard");
const sathiTable = () => import("@/views/seva/sathiTable");
const SubscriptionsViaDocSmart = () =>
  import("@/views/seva/SubscriptionsViaDocSmart");
const usersBySeva = () => import("@/views/seva/usersBySeva");
const paymentList = () => import("@/views/seva/paymentList");
const sevaDashboard = () => import("@/views/seva/sevaDashboard");
const docsmartInsuranceDoctors = () => import("@/views/insuranceDoctors.vue");
const docsmartInsuranceAllied = () => import("@/views/insuranceAllied.vue");
const docsmartInsuranceCentres = () => import("@/views/insuranceCentres.vue");
const onlineConsultationRefund = () =>
  import("@/views/dashboardNew/Accounts/onlineConsultationRefund.vue");
  const documents = () => import("@/views/documents/documents.vue");
Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  //mode: "hash", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  //scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let permissions_name = to.meta.permissions_name;
    // super admin only routes check is_super instead of a permission
    const isAllowed = (userDetails) =>
      to.meta.superAdminOnly
        ? userDetails.is_super === true
        : userDetails.permissions.includes(permissions_name);
    if (
      userStore &&
      userStore.state &&
      userStore.state.userDetails &&
      userStore.state.userDetails.permissions &&
      userStore.state.userDetails.permissions.length
    ) {
      if (isAllowed(userStore.state.userDetails)) {
        next();
      } else {
        next("/page/404");
      }
    } else {
      let url = `${config.BASE_URL}api/v2/admin/login/users/info`;
      Vue.http
        .get(url)
        .then((response) => {
          if (response.body.status) {
            let userDetails = response.body.data;
            if (
              userDetails &&
              userDetails.permissions &&
              userDetails.permissions.length &&
              isAllowed(userDetails)
            ) {
              next();
            } else {
              next("/page/404");
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching user details:", error);
          next("/page/404");
        });
    }
  } else {
    next();
  }
});


function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "login",
          name: "Login",
          component: Login,
        },
      ],
    },
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      component: TheContainer,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          // meta: { requiresAuth: true ,permissions_name:"VIEW_DASHBOARD"},
        },
        {
          path: "traction",
          name: "Traction Metrics",
          component: TractionDashboard,
          meta: { requiresAuth: true, superAdminOnly: true },
        },

        {
          path: "role",
          name: "Role",
          component: Role,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ROLE"},
        },
        {
          path: "admin-user",
          name: "Admin User",
          component: AdminUser,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ADMIN_USER"},

        },
        {
          path: "mobile-version",
          name: "Mobile Version",
          component: MobileVersion,
          meta: { requiresAuth: true ,permissions_name:"VIEW_MOBILE_VERSION"},
        },
        {
          path: "release",
          name: "Releases",
          component: Releases,
        },
        {
          path: "releasedata",
          name: "ReleaseData",
          component: ReleaseData,
        },
        {
          path: "referred-marketing-users-list",
          name: "Referred Marketing Users List",
          component: ReferredUsersList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REFERRED_MARKETING_USERS_LIST"},
        },
        {
          path: "referral-marketing-agencies",
          name: "Referral Marketing Agencies",
          component: ReferralMarketingAgenciesListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REFERRAL_MARKETING_AGENCIES"},
        },
        {
          path: "subscription-list/:role?",
          name: "Subscription List",
          component: subscriptionList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SUBSCRIPTION_LIST"},
        },
        {
          path: "subscription-dashboard",
          name: "Subscription Dashboard",
          component: subscriptionDashboard,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SUBSCRIPTION_DASHBOARD"},
        },
        {
          path: "subscription-reports",
          name: "Subscription Reports",
          component: subscriptionReports,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SUBSCRIPTION_REPORTS"},
        },
        {
          path: "subscription-plans",
          name: "Subscription Plans",
          component: subscriptionPlans,
        },
        {
          path: "subscription-plan/:id",
          name: "View Subscription",
          component: subscriptionPlan,
        },
        {
          path: "recently-expired-subscriptions",
          name: "Recently Expired Subscriptions",
          component: recentlyExpiredSubscriptions,
        },
        {
          path: "subscription-history",
          name: "Subscription History",
          component: subscriptionHistory,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SUBSCRIPTION_HISTORY"},

        },
        
        {
          path: "documents",
          name: "Documents",
          component: documents,
        },
        // ================================
        //  for cmelist
        {
          path: "cme-list",
          name: "CME Listing",
          component: cmeList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CME_LISTING"},
        },
        // ================================

        // ================================
        //  for cmeDetails
        {
          path: "cme-events/:slug",
          name: "Cme Details",
          component: cmeDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CME_LISTING"},
        },
        {
          path: "cme-reports",
          name: "Cme Reports",
          component: cmeReports,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CME_LISTING"},
        },
        // ================================

        {
          path: "health-package",
          name: "Health Package",
          component: healthPackageListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCTOR_DOCSMART_TESTS_MASTER"},
        },

        {
          path: "health-package-details",
          name: "Health Package Details",
          component: healthPackageDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCTOR_DOCSMART_TESTS_MASTER"},

        },
        // ================================

        {
          path: "pay-per-use-dashboard",
          name: "Pay Per Use",
          component: payPerUseDashboard,
          meta: { requiresAuth: true ,permissions_name:"SHOW_PAY_PER_USE"},

        },
        {
          path: "owner-list",
          name: "Owner List",
          component: ownerList,
          meta: { requiresAuth: true ,permissions_name:"SHOW_PAY_PER_USE_OWNER"},
        },

        {
          path: "centre-list",
          name: "Centre List",
          component: centreList,
          meta: { requiresAuth: true ,permissions_name:"SHOW_PAY_PER_USE_CENTER_LIST"},
        },

        {
          path: "settings",
          name: "Settings",
          component: settings,
          meta: { requiresAuth: true ,permissions_name:"SHOW_PAY_PER_USE_SETTINGS"},
        },
        // ================================

        {
          path: "seva-dashboard",
          name: "Seva Dashboard",
          component: sevaDashboard,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_SEVA"},
        },
        {
          path: "sathi-table",
          name: "Sathi Details",
          component: sathiTable,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_SEVA"},
        },
        {
          path: "subscriptions-via-DocSmart",
          name: "Subscriptions via DocSmart",
          component: SubscriptionsViaDocSmart,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_SEVA"},
        },

        {
          path: "users-by-seva",
          name: "Users by SEVA",
          component: usersBySeva,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_SEVA"},
        },

        {
          path: "payment-list",
          name: "Payment List",
          component: paymentList,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_SEVA"},
        },
        // ================================
        {
          path: "doctor-data",
          name: "Doctor Data",
          component: DoctorData,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCTOR_DATA_REPORTS"},
        },
        {
          path: "city-wise-doctors",
          name: "City-wise Doctors",
          component: CityWiseDoctors,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CITY_WISE_DOCTORS"},
        },
        {
          path: "user-profile",
          name: "User Profile",
          component: UserProfile,
        },
        {
          path: "assigned-tickets",
          name: "Assigned Tickets",
          component: AssignedTickets,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ASSIGNED_TICKETS"},
        },
        {
          path: "report-inappropriate",
          name: "Report Inappropriate",
          component: ReportInappropriate,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REPORT_INAPPROPRIATE"},
        },
        {
          path: "suggestions",
          name: "Suggestions",
          component: Suggestions,
        },
        {
          path: "ticket-list",
          name: "Ticket List",
          component: TicketList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CUSTOMER_TICKET_LIST"},
        },
        {
          path: "nameChangeList",
          name: "Name Change List",
          component: nameChangeList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_NAME_CHANGE_REQUEST"},
        },
        {
          path: "userListing",
          name: "User Listing",
          component: userListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_LIST"},
        },
        {
          path: "staffListing",
          name: "Staff Listing",
          component: staffListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_LIST"},
        },

        // New Hospital Listing Page
        {
          path: "hospitalListing",
          name: "Hospital Listing",
          component: hospitalListing,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_DETAILS_HOSPITAL_LISTING"},
        },
        // New Hospital Listing Page

        // New Hospital Listing Detail Page
        {
          path: "hospitalListingDetails",
          name: "Hospital Listing Details",
          component: hospitalListingDetail,
          meta: { requiresAuth: true ,permissions_name:"CAN_VIEW_DETAILS_HOSPITAL_LISTING"},
        },
        // New Hospital Listing Detail Page

        // New Hospital Approval Page
        {
          path: "hospitalApprovalList",
          name: "Hospital Approval List",
          component: hospitalApproval,
          meta: { requiresAuth: true ,permissions_name:"VIEW_HOSPITAL_APPROVAL"},
        },
        // New Hospital Approval Page

        // New Hospital Approval Detail Page
        {
          path: "hospitalApprovalDetails",
          name: "Hospital Approval Details",
          component: hospitalApprovalDetail,
          meta: { requiresAuth: true ,permissions_name:"VIEW_HOSPITAL_APPROVAL"},

        },
        // New Hospital Approval Detail Page

        {
          path: "usersActivity",
          name: "Users Activity",
          component: activeUsers,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USERS_ACTIVITY"}
        },

        {
          path: "inactiveUsers",
          name: "Inactive Users",
          component: inactiveUsers,
        },
        {
          path: "user-list",
          name: "User Search",
          component: userList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_LIST"},
        },
        {
          path: "CentreApproval",
          name: "Centre Approval",
          component: CentreApproval,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CENTER_APPROVAL"},
        },
        {
          path: "push-notification",
          name: "Push Notification",
          component: pushNotification,
          meta: { requiresAuth: true ,permissions_name:"CAN_SEND_PUSH_NOTIFICATION"},
        },

        {
          path: "accounts-master",
          name: "Accounts Master",
          component: accountsMaster,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ACCOUNT_MASTER"},
        },
        {
          path: "withdrawalList",
          name: "Withdrawal List",
          component: withdrawalList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ACCOUNT_WITHDRAWAL_LIST"},
        },
        {
          path: "accounts-settings",
          name: "Accounts Settings",
          component: accountSettings,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ACCOUNT_SETTINGS"},
        },
        {
          path: "corrupted-transactions",
          name: "Corrupted Transactions",
          component: corruptedTransactions,
        },
        {
          path: "online-consultation-refund",
          name: "online Consultation Refund",
          component: onlineConsultationRefund,
        },
        {
          path: "log-details",
          name: "Log Details",
          component: LogDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_LOGS"},
        },
        {
          path: "log-transport",
          name: "Log Transport",
          component: LogTransport,
          meta: { requiresAuth: true ,permissions_name:"VIEW_TRANSPORT_LOGS"},
        },
        {
          path: "log-ambulance",
          name: "Log Ambulance",
          component: LogDetailsAmbulance,
          meta: { requiresAuth: true ,permissions_name:"VIEW_AMBULANCE_LOGS"},
        },

        {
          path: "sms-log",
          name: "Sms Log",
          component: smsLog,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SMS_LOGS"},
        },
        {
          path: "Referred-List",
          name: "Referred List",
          component: ReferredList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REFERRED_LIST"},
        },

        {
          path: "Referred-Listing",
          name: "Referred Listing",
          component: ReferredListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REFERRED_LISTING"},
        },

        {
          path: "Referral-Dashboard",
          name: "Referral Dashboard",
          component: ReferralDashboard,
          meta: { requiresAuth: true ,permissions_name:"VIEW_REFERRAL_DASHBOARD"},
        },
      
        {
          path: "enrolled-organizations",
          name: "Enrolled Organizations",
          component: EnrolledOrganizations,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ENROLLED_ORGANIZATIONS"},
        },
        {
          path: "enrolled-viewdetails",
          name: "Enrolled View Details",
          component: EnrolledViewDetails,
        },
        {
          path: "enrolled-coupontransaction-history",
          name: "Enrolled Coupon Transaction History",
          component: enrolledCouponTransactionHistory,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USAGE_HISTORY"},
        },
      
        {
          path: "centerListing",
          name: "Centre Listing",
          component: centreListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CENTER_LIST"},
        },
        {
          path: "doctor-list",
          name: "Doctor List",
          component: doctorList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCTOR_APPROVAL"},
        },
        {
          path: "allied-list",
          name: "Allied List",
          component: alliedList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCTOR_APPROVAL"},
        },
        {
          path: "red-flag",
          name: "Red Flag",
          component: RedFlag,
          meta: { requiresAuth: true ,permissions_name:"VIEW_RED_FLAG_REQUEST"},
        },
        {
          path: "chats",
          name: "Chats",
          component: Chats,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CHAT"},
        },
        {
          path: "blogs-listing",
          name: "Blogs Listing",
          component: BlogsListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ADMIN_BLOGS"},
        },

        {
          path: "user-blog-list",
          name: "User Blog List",
          component: userBlogList,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_BLOGS"},
        },
        {
          path: "createBlog",
          name: "Create Blog",
          component: CreateBlog,
          meta: { requiresAuth: true ,permissions_name:"CAN_CREATE_ADMIN_BLOGS"},
          props: true,
        },
        {
          path: "blog/:slug",
          name: "Blog Details",
          component: BlogDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ADMIN_BLOGS"},
        },
        {
          path: "user-blog/:slug",
          name: "User Blog Details",
          component: userBlogDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_BLOGS"},

        },
        {
          path: "newsListing",
          name: "News Listing",
          component: newsListing,
          meta: { requiresAuth: true ,permissions_name:"VIEW_NEWS_LISTING"},
        },
        {
          path: "createNews",
          name: "Create News",
          component: CreateNews,
          meta: { requiresAuth: true ,permissions_name:"CAN_CREATE_NEWS_LISTING"},
        },
        {
          path: "news/:slug",
          name: "News Details",
          component: newsDetails,
          meta: { requiresAuth: true ,permissions_name:"VIEW_NEWS_LISTING"},
        },
        {
          path: "chats/:chatId/:user_name",
          name: "chat",
          component: Chat,
          meta: { requiresAuth: true ,permissions_name:"VIEW_CHAT"},
        },
        {
          path: "insurance-doctor",
          name: "Insurance Doctors",
          component: docsmartInsuranceDoctors,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_DOCTOR"},

          
        },
        {
          path: "insurance-allied",
          name: "Insurance Allied",
          component: docsmartInsuranceAllied,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_ALLIED"},

        },
        {
          path: "insurance-pharmacy",
          name: "Insurance Pharmacy",
          component: docsmartInsuranceCentres,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_PHARMACY"},

        },
        {
          path: "insurance-ambulance",
          name: "Insurance Ambulance",
          component: docsmartInsuranceCentres,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_AMBULANCE"},

        },
        // {
        //   path: "insurance-bloodbank",
        //   name: "Insurance Bloodbank",
        //   component: docsmartInsuranceCentres,
        //   meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_DIAGNOSTICS"},

        // },
        {
          path: "insurance-diagnostics-lab",
          name: "Insurance Diagnostics",
          component: docsmartInsuranceCentres,
          meta: { requiresAuth: true ,permissions_name:"VIEW_DOCSMART_INSURANCE_DIAGNOSTICS"},

        },
        {
          path: "docsmart-dashboard",
          name: "DocSmart Dashboard",
          component: docsmartDashboard,
        },
        {
          path: "subscription-masters",
          name: "Subscription Masters",
          component: subscriptionDashboardMasters,
          meta: { requiresAuth: true ,permissions_name:"VIEW_SUBSCRIPTION_LIST"},

        },
        {
          path: "services-dashboard",
          name: "Services Dashboard",
          component: servicesDashboard,
        },
        {
          path: "user-data",
          name: "User Data",
          component: userData,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_LIST"},
        },

        {
          path: "getOtp",
          name: "Get OTP",
          component: getOtp,
          meta: { requiresAuth: true ,permissions_name:"VIEW_USER_REGISTRATION_OTP"},
        },
        {
          path: "active-modules",
          name: "Active Modules",
          component: ActiveModules,
          meta: { requiresAuth: true ,permissions_name:"VIEW_ACTIVE_MODULE"},
        },
        {
          path: "import-centers/:center_type",
          name: "Import Centers",
          component: importCenters,
          meta: { requiresAuth: true ,permissions_name:"IMPORT_CENTERS"},
        },
        {
          path: "theme",
          redirect: "/theme/colors",
          name: "Theme",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "colors",
              name: "Colors",
              component: Colors,
            },
            {
              path: "typography",
              name: "Typography",
              component: Typography,
            },
          ],
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "widgets",
          name: "Widgets",
          component: Widgets,
        },
        {
          path: "users",
          meta: {
            label: "Users",
          },
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Users",
              component: Users,
            },
            {
              path: ":id",
              meta: {
                label: "User Details",
              },
              name: "User",
              component: User,
            },
          ],
        },
        {
          path: "base",
          redirect: "/base/cards",
          name: "Base",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "cards",
              name: "Cards",
              component: Cards,
            },
            {
              path: "forms",
              name: "Forms",
              component: Forms,
            },
            {
              path: "switches",
              name: "Switches",
              component: Switches,
            },
            {
              path: "tables",
              name: "Tables",
              component: Tables,
            },
            {
              path: "tabs",
              name: "Tabs",
              component: Tabs,
            },
            {
              path: "breadcrumbs",
              name: "Breadcrumbs",
              component: Breadcrumbs,
            },
            {
              path: "carousels",
              name: "Carousels",
              component: Carousels,
            },
            {
              path: "collapses",
              name: "Collapses",
              component: Collapses,
            },
            {
              path: "jumbotrons",
              name: "Jumbotrons",
              component: Jumbotrons,
            },
            {
              path: "list-groups",
              name: "List Groups",
              component: ListGroups,
            },
            {
              path: "navs",
              name: "Navs",
              component: Navs,
            },
            {
              path: "navbars",
              name: "Navbars",
              component: Navbars,
            },
            {
              path: "paginations",
              name: "Paginations",
              component: Paginations,
            },
            {
              path: "popovers",
              name: "Popovers",
              component: Popovers,
            },
            {
              path: "progress-bars",
              name: "Progress Bars",
              component: ProgressBars,
            },
            {
              path: "tooltips",
              name: "Tooltips",
              component: Tooltips,
            },
          ],
        },
        {
          path: "buttons",
          redirect: "/buttons/standard-buttons",
          name: "Buttons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "standard-buttons",
              name: "Standard Buttons",
              component: StandardButtons,
            },
            {
              path: "button-groups",
              name: "Button Groups",
              component: ButtonGroups,
            },
            {
              path: "dropdowns",
              name: "Dropdowns",
              component: Dropdowns,
            },
            {
              path: "brand-buttons",
              name: "Brand Buttons",
              component: BrandButtons,
            },
          ],
        },
        {
          path: "icons",
          redirect: "/icons/coreui-icons",
          name: "CoreUI Icons",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "coreui-icons",
              name: "Icons library",
              component: CoreUIIcons,
            },
            {
              path: "brands",
              name: "Brands",
              component: Brands,
            },
            {
              path: "flags",
              name: "Flags",
              component: Flags,
            },
          ],
        },
        {
          path: "notifications",
          redirect: "/notifications/alerts",
          name: "Notifications",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "alerts",
              name: "Alerts",
              component: Alerts,
            },
            {
              path: "badges",
              name: "Badges",
              component: Badges,
            },
            {
              path: "modals",
              name: "Modals",
              component: Modals,
            },
          ],
        },
        {
          path: "/pages",
          redirect: "/pages/404",
          name: "Pages",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "404",
              name: "Page404",
              component: Page404,
            },
            {
              path: "500",
              name: "Page500",
              component: Page500,
            },
          ],
        },
        {
          path: "logs/:domain",
          name: "logs",
          component: Logs,
        },
        {
          path: "master",
          name: "Master",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "tests",
              name: "Test",
              component: MasterTest,
            },
            {
              path: "doctor-tests",
              name: "DoctorTest",
              component: DoctorTest,
            },
            {
              path: "medicine",
              name: "Medicine",
              component: pharmacyMasters,
            },
            {
              path: "doctor-medicines",
              name: "Doctor Medicines",
              component: pharmacyDoctorMedicines,
            },
          ],
        },
      ],
    },
    {
      path: "/",
      redirect: "/pageNotFound",
      name: "pageNotFound",
      component: pageNotFound,
      children: [
        {
          path: "*",
          name: "pageNotFound",
          component: pageNotFound,
        },
      ],
    },
  ];
}

// Authentication for each routes. - START
// router.beforeEach((to, from, next) => {
//   const isLoggedIn = localStorage.getItem("token") ? true : false;
//   if (isLoggedIn === false && to.name !== "Login") {
//     router.push({
//       name: "Login",
//     });
//   } else {
//     next();
//   }
// });
// Authentication for each routes. - END

export default router;
